'use client';

import {
  HUB_URL,
  useIothubHub,
  useSpotcontrolHub,
  useTelemetryHub,
  useTeleoperationHub,
  useTwinHub,
} from './index.ts';
import { useRosbridgeHub } from './useRosbridgeHub.ts';

export type Hubs = ReturnType<typeof useAllHubs>;

export function useAllHubs() {
  return {
    [HUB_URL.IOTHUB]: useIothubHub(),
    [HUB_URL.TELEMETRY]: useTelemetryHub(),
    [HUB_URL.TELEOPERATION]: useTeleoperationHub(),
    [HUB_URL.SPOTCONTROL]: useSpotcontrolHub(),
    [HUB_URL.ROSBRIDGE]: useRosbridgeHub(),
    [HUB_URL.TWIN]: useTwinHub(),
  };
}
